import { Injectable } from '@angular/core';
import { NewSourceModel } from '../models/new-source.model';
import { SourceType } from '../models/source.model';


interface GemaraLocationInterface {
  daf:number,
  amud:'a'|'b',
}



interface MishnaLocationInterface {
  perek:number,
  mishna:number,
}



@Injectable()
export class HebrewService {

  constructor() {
  }



  getHebrewGemaraLocation(location:GemaraLocationInterface) {
    return this.getHebrewNumber(location.daf) + this.getHebrewAmud(location.amud);
  }


  getHebrewMishnaLocation(location:MishnaLocationInterface) {
    if (location.mishna == null) {
      return this.getHebrewNumber(location.perek);
    } else {
      return this.getHebrewNumber(location.perek) + ',' + this.getHebrewNumber(location.mishna);
    }
  }


  getHebrewNumber(daf:number):string {


    // special cases
    switch (daf) {
      case 15:
        return 'טו';
      case 16:
        return 'טז';
      case 115:
        return 'קטו';
      case 116:
        return 'קטז';
    }



    let output = '';


    if (daf >= 100) {
      output += 'ק';
      daf -= 100;
    }

    if (daf >= 90) {
      output += 'צ';
      daf -= 90;
    }

    if (daf >= 80) {
      output += 'פ';
      daf -= 80;
    }

    if (daf >= 70) {
      output += 'ע';
      daf -= 70;
    }

    if (daf >= 60) {
      output += 'ס';
      daf -= 60;
    }

    if (daf >= 50) {
      output += 'נ';
      daf -= 50;
    }

    if (daf >= 40) {
      output += 'מ';
      daf -= 40;
    }

    if (daf >= 30) {
      output += 'ל';
      daf -= 30;
    }

    if (daf >= 20) {
      output += 'כ';
      daf -= 20;
    }

    if (daf >= 10) {
      output += 'י';
      daf -= 10;
    }

    switch (daf) {
      case 9:
        output += 'ט';
        break;
      case 8:
        output += 'ח';
        break;
      case 7:
        output += 'ז';
        break;
      case 6:
        output += 'ו';
        break;
      case 5:
        output += 'ה';
        break;
      case 4:
        output += 'ד';
        break;
      case 3:
        output += 'ג';
        break;
      case 2:
        output += 'ב';
        break;
      case 1:
        output += 'א';
        break;
      case 0:
        // do nothing
        break;
      default:
        console.log('************************************************************ ERROR ************************************************************');
        console.log('daf', daf);
        process.exit();
        break;
    }


    return output;
  }



  getHebrewAmud(amud:'a'|'b'|''):string {
    if (amud == 'a') return '.';
    if (amud == 'b') return ':';
    return '';
  }


  getSourceRenderTextShort(newSource:NewSourceModel):string {

    switch (newSource.sourceType) {
      case SourceType.Gemara:
        if (newSource.isRange) {
          return this.getHebrewGemaraLocation(newSource.gemaraStartLocation) + '-' + this.getHebrewGemaraLocation(newSource.gemaraEndLocation);
        } else {
          return this.getHebrewGemaraLocation(newSource.gemaraStartLocation);
        }
      case SourceType.Mishna:
        if (newSource.isRange) {
          return this.getHebrewMishnaLocation(newSource.mishnaStartLocation) + '-' + this.getHebrewMishnaLocation(newSource.mishnaEndLocation);
        } else {
          return this.getHebrewMishnaLocation(newSource.mishnaStartLocation);
        }
      case SourceType.Literal:
        return newSource.literalText;
      case SourceType.Unknown:
      default:
        return newSource.literalText;
    }
  }


  getSourceRenderTextFull(newSource:NewSourceModel):string {
    return newSource.masechta + ' ' + this.getSourceRenderTextShort(newSource);
  }


  getHebrewLetterBySequence(letterNum:number):string {
    switch (letterNum) {
      case 1:
        return 'א';
      case 2:
        return 'ב';
      case 3:
        return 'ג';
      case 4:
        return 'ד';
      case 5:
        return 'ה';
      case 6:
        return 'ו';
      case 7:
        return 'ז';
      case 8:
        return 'ח';
      case 9:
        return 'ט';
      case 10:
        return 'י';
      case 11:
        return 'כ';
      case 12:
        return 'ל';
      case 13:
        return 'מ';
      case 14:
        return 'נ';
      case 15:
        return 'ס';
      case 16:
        return 'ע';
      case 17:
        return 'פ';
      case 18:
        return 'צ';
      case 19:
        return 'ק';
      case 20:
        return 'ר';
      case 21:
        return 'ש';
      case 22:
        return 'ת';
    }
  }
}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/services/hebrew.service.ts